import { render, staticRenderFns } from "./PufaOnlineAuth.vue?vue&type=template&id=7cbb4957&scoped=true"
import script from "./PufaOnlineAuth.vue?vue&type=script&lang=js"
export * from "./PufaOnlineAuth.vue?vue&type=script&lang=js"
import style0 from "./PufaOnlineAuth.vue?vue&type=style&index=0&id=7cbb4957&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cbb4957",
  null
  
)

export default component.exports